import storageManager from '@/shared/storageManager';
import { useLogin } from '@/hooks/useLogin';
import { useRegistration } from '@/hooks/useRegistration';
import { OpenedFrom } from '@/lib/gTagManager';

type AuthenticationMethod = (openedFrom: OpenedFrom) => void;

const useAuthentication = () => {
  const isReturningUser = storageManager.getIsReturningUser();
  const { openLogin } = useLogin();
  const { openRegistration } = useRegistration();

  const openAuthentication: AuthenticationMethod = isReturningUser
    ? openedFrom => openLogin({ openedFrom })
    : openedFrom => openRegistration({ openedFrom });

  return { openAuthentication, isReturningUser };
};

export default useAuthentication;
